class UspBar extends AnnouncementBar {
  get sliderClass() {
    return '.usp-slider';
  }

  initOnDesktop() {
    switch (this.dataset.layout) {
      case 'marquee':
        this.initMarquee();
        break;
      case 'carousel':
      case 'static':
      default:
        break;
    }
  }

  initOnMobile() {
    switch (this.dataset.mobileLayout) {
      case 'carousel':
        this.initCarousel(true);
        break;
      case 'marquee':
        this.initMarquee();
        break;
    }
  }

  initCarousel(isMobile = false) {
    if (this.dataset.blockCount == 1) return;

    const slider = this.querySelector(this.sliderClass);
    setTimeout(() => {
      this.flickity = new Flickity(slider, {
        accessibility: false,
        rightToLeft: theme.config.rtl,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        autoPlay: isMobile && this.config.autorotate ? this.config.autorotateSpeed : false,
      });
    });

    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    this.onNextPrevClick = this.handleNextPrevClick.bind(this);
    this.prevButton && this.prevButton.addEventListener('click', this.onNextPrevClick);
    this.nextButton && this.nextButton.addEventListener('click', this.onNextPrevClick);
  }
}

customElements.define('usp-bar', UspBar);
